import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/motivoscancelamentos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const store = async ({ companyCnpj, body }) =>
  search(`${path}?empresa_cnpj=${companyCnpj}`, "POST", headers, body);

export const show = async ({ companyCnpj, id }) =>
  search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${companyCnpj}&include=motivocancelamentoempresa`,
    "GET",
    headers
  );

export const update = async ({ companyCnpj, id, body }) =>
  search(`${path}/${id}?empresa_cnpj=${companyCnpj}`, "PUT", headers, body);

export const destroy = async ({ companyCnpj, id }) =>
  search(`${path}/${id}?empresa_cnpj=${companyCnpj}`, "DELETE", headers);
